import type StatusChangedMsg from '@apptypes/WebsocketUserStatus.ts';
import { useAuth } from '@hooks/useAuth.tsx';
import { useEffect, useRef } from 'react';
import { useSocket } from '../../containers/websocket-provider.tsx';

export function WebSocketStatusChangedWatcher() {
  const { getLatest } = useSocket();
  const statusChanged = getLatest('status_changed');
  const { user, updateUser } = useAuth();
  const lastProcessedRef = useRef<StatusChangedMsg>();

  useEffect(() => {
    if (!user.logged_in) return;
    if (!statusChanged) return;
    if (lastProcessedRef.current === statusChanged) return;

    lastProcessedRef.current = statusChanged;
    updateUser(true);
  }, [statusChanged, user.logged_in, updateUser]);

  return null;
}
